<template>
  <div class="template-chart">
    <b-card :title="chartTitle" class="chart-container" sub-title="Notification activity">
      <apexchart id="template-chart-box" type="bar" :options="chartOptions" :series="series" v-if="isLoaded"></apexchart>
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
var Parse = require('parse/node');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY, process.env.VUE_APP_PARSE_MASTER_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;
var moment = require('moment');

export default {
  name: 'TemplateChartComponent',
  components: { 
    'apexchart': VueApexCharts,
  },
  props: {
    templateId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      chartOptions : null,      
      series : null,
      isLoaded : false,
      btn1label : "",
      btn2label : "",
      btn3label : "",
      chartTitle : "",
    }
  },
  watch: {
    templateId: function (val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal);
      this.fetchTemplateData();
    }
  },
  created() {
    this.fetchTemplateData();
  },
  methods: {
    fetchTemplateLabels: async function() {
      const NotificationTemplate = Parse.Object.extend("NotificationTemplate");
      const query = new Parse.Query(NotificationTemplate);
      query.equalTo("objectId", this.templateId);

      let templateResult = await query.first();
      if (templateResult) {
        if (templateResult.get("Button1Label")) {
          this.btn1label = templateResult.get("Button1Label") + " clicked";
        } else {
          this.btn1label = '';
        }
        if (templateResult.get("Button2Label")) {
          this.btn2label = templateResult.get("Button2Label") + " clicked";
        } else {
          this.btn2label = '';
        }
        if (templateResult.get("Button3Label")) {
          this.btn3label = templateResult.get("Button3Label") + " clicked";
        } else {
          this.btn3label = '';
        }
        this.chartTitle = templateResult.get("Name");
      }
    },

    fetchTemplateData: async function () {
      
      await this.fetchTemplateLabels();
      const AppMessage = Parse.Object.extend("AppMessage");
      const query = new Parse.Query(AppMessage);
      query.descending("createdAt");
      var pipeline = [
        { match: { CompanyId: this.companyId, TemplateId: this.templateId  } },
        { group: { objectId: { status: '$Status', btn1status: '$Button1Status', btn2status: '$Button2Status', btn3status: '$Button3Status' },
                   total: { $sum: 1 } 
                 } 
        }
      ];      
      let timeSeriesData = [];
      let timeSeriesDataUnread = [];
      let results = await query.aggregate(pipeline);
      console.log('TEMPLATE results = ' + JSON.stringify(results));
      let sentTotal = 0;
      let readTotal = 0;
      let btn1Total = 0;
      let btn2Total = 0;
      let btn3Total = 0;

      results.forEach(element => {
        let cur = JSON.parse(JSON.stringify(element));
        sentTotal += cur.total;
        if (cur.objectId.status == "Read") {
          readTotal += cur.total;
        }
        if (cur.objectId.btn1status == "Clicked") {
          btn1Total += cur.total;
        }
        if (cur.objectId.btn2status == "Clicked") {
          btn2Total += cur.total;
        }
        if (cur.objectId.btn3status == "Clicked") {
          btn3Total += cur.total;
        }
        
      });

      this.chartOptions = {
        chart: {
            id: 'template-chart-box',
            type: "bar",
            stacked: false,
            toolbar: {
              show: false,
            }
        },
        xaxis: {
          categories: ['Sent', 'Read', this.btn1label, this.btn2label, this.btn3label]
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true
          }          
        },
        theme: {
          monochrome: {
            enabled: true,
            //color: '#775dd0',
            color: '#5520a7',
            shadeTo: 'light',
            shadeIntensity: 0.9
          }
        }
      };
      this.series = [
        {
          name: 'Total',
          data: [sentTotal, readTotal, btn1Total, btn2Total, btn3Total]
        }];

      
      this.isLoaded = true;
      
    }
  }
}
</script>
<style scoped>

</style>